class BlockStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.state = {
            variant: {},
        };

        this.props = {
            productTitle: '',
            defaultVariant: {},
            addToCartText: '',
            soldOutText: ''
        }
    }

    initState() {
        this.state.variant = this.props.defaultVariant;
    }

    initProps() {
        this.props = {
            productTitle: this.getAttribute(':productTitle'),
            defaultVariant: JSON.parse(this.getAttribute(':defaultVariant')),
            addToCartText: this.getAttribute(':addToCartText'),
            soldOutText: this.getAttribute(':soldOutText'),
        }
    }

    initIntersection() {
        const stickyAddToCart = document.getElementById('sticky-add-to-cart');

        const observer = new IntersectionObserver(handleIntersection);
        observer.observe(document.getElementById('primary-add-to-cart'));

        function handleIntersection(entries) {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    stickyAddToCart.classList.add('!opacity-0');
                } else {
                    stickyAddToCart.classList.remove('!opacity-0');
                }
            });
        }
    }

    initEventListeners() {
        this.querySelector('button').addEventListener('click', () => {
            $('#primary-add-to-cart button[type="submit"]').click();
        })
    }

    updateState(state) {
        this.state = {
            ...this.state,
            ...state,
        }

        this.render();
        this.initEventListeners();
    }

    updateButtonState(state) {
        this.updateState({ variant: { ...state } });
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.initIntersection();
        this.render();
        this.initEventListeners();
    }

    render() {
        const { addToCartText, soldOutText, productTitle } = this.props;
        const { variant } = this.state;
        const { available, compare_at_price, price } = variant;

        this.innerHTML = `
        <div class="flex items-center justify-between p-4 bg-white shadow-md">
            <block-sticky-item 
                :title="${productTitle}"
                :compareAtPrice="${compare_at_price}"
                :price="${price}"
            >
            </block-sticky-item>
            <button 
                ${!available ? 'disabled' : ''}
                class="${!available ? 'opacity-40' : ''} w-[120px] h-[30px] text-center rounded-3xl bg-[#FF8900] px-5 py-2 text-[13px] font-bold text-white sticky-add-to-cart__button">
                <span class="sticky-add-to-cart__text">${available ? addToCartText : soldOutText}</span>
                <div class="loading-overlay__spinner mx-auto hidden">
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        role="presentation"
                        class="spinner"
                        viewBox="0 0 66 66"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </button>
        </div>
        `
    }
}

customElements.define('block-sticky-add-to-cart', BlockStickyAddToCart);